/* eslint-disable react/jsx-key */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react'
import { useLocation,useNavigate } from 'react-router-dom'
import { GenerateDateandTime, GenerateDateFormat, generateDateWithTime } from '../../redux/helper/DateConverter'
import { distributorService } from '../../service/distributor.service'


const NotificationDropdown = ({notificationDropdown,setNotificationDropdown, notificationList, setNotificationList, notificationCount, setNotificationCount, notificationRef, handleFetchNotifications}) => {
    const navigate = useNavigate();

    const handleReadStatus = async (item) => {
        if(item.read_status === false) {
            const payload = {
                read_status : (item.read_status === false) ? true : false
            }
            const response = await distributorService.NotificationListStatusUpdate(item.notification_id, payload)
        }
        if(item.type === 'order') {
            setNotificationDropdown(false)
            navigate(`/orders/${item?.info.order_number}/view`)
            handleFetchNotifications()
        }
        else if(item.type === 'invoice') {
            navigate(`/orders/${item?.info.INDENT_NUMBER}/view`)
            handleFetchNotifications()
        }

    }
       

    const clearNotification = async () => {
        const response = await distributorService.ClearNotificationList()
        setNotificationDropdown(false)
        setNotificationList([])
        setNotificationCount(0)
        // handleFetchNotifications()
    }
    
    return (
        <div>
            <div ref={notificationRef} className={`absolute sm:top-[85px] top-[50px] md:right-0 sm:right-[-216px] right-[-42px] sm:min-w-[455px] min-w-[310px] rounded-lg rounded-tr-none z-[7] shadow-s11 bg-[#ffffff] notificationSection ${notificationDropdown ? 'show' : 'hidden'}`}>
                <div className="pl-[11px] sm:py-3.5 py-2.5 flex justify-between sm:mr-5 mr-3">
                    <p className="sm:text-sm34 text-xs6 font-semibold text-[#000000]">Notifications</p>
                    <div className="flex items-center pl-3 cleared-notification">
                        <p className="sm:text-sm text-sm42 font-normal text-[#555259]">{notificationCount} Unread Notifications</p>
                        <button 
                            onClick={() => clearNotification()}
                            type="button" 
                            className="sm:text-sm text-sm42 font-normal text-[#000000] ml-2.5 clear-notification">Clear All</button>
                    </div>
                </div>
                <div className="sm:pr-[7px] pr-0.5 notification-filled w-full border-t border-[#E9EDF4]">
                    <div className="pr-[8px] max-h-[60vh] scrollbarGray overflow-auto rounded-b-lg mb-1">
                        {notificationList.length > 0 && notificationList.map((item, idx) => (
                            <div 
                                key={idx} 
                                className={`${item?.read_status === false ? 'border-l-2 border-[#ED1C24]' : ''} sm:pl-[11px] pl-2 sm:pt-[13px] pt-2 sm:pr-2 pr-1.5 pb-[3px] bg-[#FAFAFA] sm:mb-2.5 mb-1.5`}
                                onClick={() => handleReadStatus(item)}
                            >                              
                                <a className="cursor-pointer">
                                    <p className={`text-sm font-semibold ${item?.read_status === false ? 'text-[#000000]' : 'text-[#555259]'}`}>{item?.message}</p>
                                    <p className="text-end">
                                        <span className={`text-sm38 font-semibold ${item?.read_status === false ? 'text-[#000000]' : 'text-[#555259]'} mr-1.5`}>{generateDateWithTime(item?.created_at)}</span>
                                    </p>
                                </a>
                            </div>
                        ))}                     
                    </div>
                </div>
                {notificationList.length === 0 && (
                    <div className="notification-empty ">
                        <div className="w-full flex flex-col justify-center items-center min-h-[60vh] px-2 text-center">
                            <img src="images/Group8022.svg" alt="icon" className="w-[72px] h-[72px]"/>
                            <p className="sm:text-base text-sm font-normal text-[#15090E] sm:pt-[18px] pt-3.5">Looks like there aren't any <span className="text-[#ED1C24]"> Notifications </span>yet!</p>
                        </div>
                    </div>
                )}
                
            </div>
      
        </div>
    )
}

export default NotificationDropdown
